﻿import { Button, Col, Modal, Radio } from "antd";
import styled from "styled-components";

export const FullscreenModal = styled(Modal)`
  .ant-modal,
  .ant-modal-content {
    height: 100vh;
    width: 95vw;
    margin: 0;
    top: 0;
    left: -130%;
  }
  .ant-modal-body {
    height: calc(100vh - 110px);
  }
`;

export const MilestoneActionCol = styled(Col)`
  display: flex;
  align-items: center;
  height: 100%;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
`;

interface IActionDrawerProps {
  open: boolean;
}

export const ActionDrawer = styled.div<IActionDrawerProps>`
  height: 100%;
  ${({ open }) =>
    open &&
    `
      right: 0;
      z-index: 1;
      position: absolute;
      display: flex;
      background-color: white;
    `}
`;

export const MilestoneActionButton = styled(Button)`
  border-left: 1px solid #dae8fb;
  border-right: 1px solid #dae8fb;
  border-radius: 0;
  min-width: 60px;
  width: fit-content;
  font-size: 10px;
  color: #448eec;
  font-weight: bold;
  height: 100%;
  &:hover {
    background-color: #dae8fb !important;
    color: #000000;
  }
`;

export const ToggleDrawerButton = styled(Button)`
  overflow: "hidden";
  max-width: "100%";
  width: 20px !important;
  background-color: #dae8fb;
  border-left: 1px solid #808080;
  border-radius: 0;
  display: flex;
  align-items: center;
  place-content: center;
  height: 100%;
`;

export const CtqSnapshotRow = styled.div`
  margin-top: 8px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  gap: 40px;
`;

export const CtqSnapshotItem = styled.div`
  display: flex;
  align-items: center;
  gap: 4px; // link ↔ button
`;

export const CtqSnapshotLink = styled.a`
  white-space: nowrap;
`;

export const CtqSkuStack = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
`;

export const CtqSkuRadioGroup = styled(Radio.Group)`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  gap: 16px;

  .ant-radio-wrapper {
    margin-inline-end: 0;
    white-space: nowrap;
  }
`;
